export const routes = {
  home: "/",
  profile: "/profile",
  login: "/login",
  register: "/register",

  npaProperties: "/npa-properties",
  addNpaProperties: "/npa-properties/add",
  editNpaProperties: "/npa-properties/edit/:id",
  viewNpaProperties: "/npa-properties/property-details/:id",

  npaInquiries: "/npa-inquiries",
  
  allUsers: "/all-users",
  requestedUser: "/requested-user",
  approvedUser: "/approved-user",
  rejectedUser: "/rejected-user",

  npaPublicProperties: "/all-properties",
  addNpaPublicProperties: "/all-properties/add",
  editNpaPublicProperties: "/all-properties/edit/:id",
  viewNpaPublicProperties: "/all-properties/property-details/:id",

  banks: "/banks",
  viewBanksDetail: "/bank-details/:id",
};
